class Logger {
  private constructor() {}

  private static instance: Logger;

  static getInstance() {
    if (!Logger.instance) {
      Logger.instance = new Logger();
    }
    if (Logger.instance.logLevel === "debug") {
      document.addEventListener("keydown", (e) => {
        if (e.key === "F1") {
          Logger.instance.setLogLevel("debug");
        } else if (e.key === "F2") {
          Logger.instance.setLogLevel("info");
        } else if (e.key === "F3") {
          Logger.instance.setLogLevel("warn");
        } else if (e.key === "F4") {
          Logger.instance.setLogLevel("error");
        }
      });
      const logViewer = document.createElement("div");
      logViewer.style.position = "relative";
      logViewer.style.width = "100%";
      logViewer.style.height = "200px";
      logViewer.style.overflow = "auto";
      logViewer.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
      logViewer.style.color = "white";
      logViewer.style.zIndex = "9999";
      document.body.appendChild(logViewer);
      Logger.instance.logViewer = logViewer;
    }
    return Logger.instance;
  }

  private logLevel: "info" | "warn" | "error" | "debug" = process.env.NODE_ENV === "production" ? "info" : "info";
  private logViewer: HTMLDivElement | null = null;

  /** true: trace daraltılmış grupta (tek tıkla açılır). DevTools’un trace’i tek başına “kapalı” API’si yok. */
  private stackTraceCollapsed = true;

  setLogLevel(level: "info" | "warn" | "error" | "debug") {
    this.logLevel = level;
  }

  getLogLevel(): "info" | "warn" | "error" | "debug" {
    return this.logLevel;
  }

  setStackTraceCollapsed(collapsed: boolean) {
    this.stackTraceCollapsed = collapsed;
  }

  getStackTraceCollapsed(): boolean {
    return this.stackTraceCollapsed;
  }

  /**
   * DevTools’ta error gibi tıklanabilir stack için Error nesnesi (düz string link olmaz).
   * V8: Logger.log çerçevesini stack’ten çıkarır.
   */
  private callerSiteError(): Error {
    const err = new Error();
    err.name = "Call site";
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(err, Logger.prototype.log);
    }
    return err;
  }

  private log(level: "info" | "warn" | "error" | "debug", objects: any[]) {
    const levelOrder = ["info", "warn", "error", "debug"];
    if (levelOrder.indexOf(level) < levelOrder.indexOf(this.logLevel)) {
      return;
    }
    const attachSite = this.logLevel === "debug" && level === "info";
    const site = attachSite ? this.callerSiteError() : undefined;
    switch (levelOrder.indexOf(level)) {
      case 0:
        if (this.logLevel === "info" || this.logLevel === "debug") {
          if (site) console.log("[INFO]", ...objects, site);
          else console.log("[INFO]", ...objects);
        }
        break;
      case 1:
        if (this.logLevel === "warn" || this.logLevel === "debug") {
          console.warn("[WARN]", ...objects);
        }
        break;
      case 2:
        if (this.logLevel === "error" || this.logLevel === "debug") {
          console.error("[ERROR]", ...objects);
        }
        break;
      case 3:
        if (this.logLevel === "debug") {
          if (this.stackTraceCollapsed) {
            console.groupCollapsed("[TRACE]", ...objects);
            console.trace();
            console.groupEnd();
          } else {
            console.trace("[TRACE]", ...objects);
          }
        }
        break;
      default:
        break;
    }
  }

  info(...objects: any[]) {
    this.log("info", objects);
  }

  warn(...objects: any[]) {
    this.log("warn", objects);
  }

  error(...objects: any[]) {
    this.log("error", objects);
  }

  debug(...objects: any[]) {
    this.log("debug", objects);
  }
}

export const logger = Logger.getInstance();
